import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'inline',
  },
  linkButton: {
    display: 'inline',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    textDecoration: 'underline',
    font: 'inherit',

    '&:visited': {
      color: theme.palette.primary.main,
    },

    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}));
